import axios from '../plugins/axios'

export default {
  data: {
    loading: false,
    success: false,
    messageType: 'error',

    email: '',
  },
  beforeMount() {
    JSON.parse(this.$el.dataset.errors).forEach(error => {
      this.errors.add({ msg: error })
    })
  },
  methods: {
    resend_activation () {
      if (this.loading) {
        return
      }

      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false
          return
        }

        this.submit()
      })
    },

    submit () {
      const formData = new FormData(this.$el)

      this.loading = true
      this.errors.clear()

      axios.post('', formData)
        .then(response => {
          this.loading = false
          this.success = true
        })
        .catch(error => {
          this.errors.add({ msg: error.response.data.data.message })
          this.loading = false
        })
    },
  },
}


// WEBPACK FOOTER //
// ./src/controllers/resend_activation.js